import type { ReactNode } from 'react';
import { useMemo } from 'react';
import { useMatches } from 'react-router';
import { z } from 'zod';

// A route supplies a component here, so the handle check confirms the slot holds something callable.
const schema = z.object({
  ViewsFilter: z.custom<(props: Record<string, unknown>) => ReactNode>((val) => typeof val === 'function'),
});

export function ViewsFilter() {
  const matches = useMatches();

  const RouteViewsFilter = useMemo(() => {
    const reversedMatches = [...matches].reverse();

    for (const match of reversedMatches) {
      const parse = schema.safeParse(match.handle);
      if (parse.success) {
        return parse.data.ViewsFilter;
      }
    }
    return undefined;
  }, [matches]);

  if (RouteViewsFilter === undefined) {
    return null;
  }

  return (
    <div>
      <RouteViewsFilter />
    </div>
  );
}
